export const isStringArray = (value: unknown | unknown[]) => {
  return Array.isArray(value) && value.every((item) => typeof item === 'string')
}
